import { IoClose } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from "react";
import { useNavigate, Link} from 'react-router-dom';
import { Post } from '../../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { Analytics, Gtag } from '../../compornents/Analytics';

export const Register = () => {
  const navigate = useNavigate();
  const [tel, setTel] = useState("");
  const telInputRef = useRef(null);

  // モーダル
  const [Modal, openModal, closeModal] = useModal('root', {
  });
  // ローディングモーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
  });


  async function send_sms() {
    closeModal();
    openLoadingModal();
    const request_data = {
      'key': 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH',
      'tel': tel,
      'is_register': 1,
    }
    // post
    const response_data = await Post('public', '/auth/send_sms.php', request_data);
    if (response_data.result === 1) {
      navigate("/register/auth", { state: { customerId: response_data.customer_id,tel:tel } });
      // SMS送信成功
      Gtag('send_sms_success');
    } else {
      // SMS送信失敗
      Gtag('send_sms_failed', {
        error_message: response_data.error_message,
      });
      // エラー
      toast.error(response_data.error_message);
    }
    closeLoadingModal();
  }

  useEffect(() => {
    Gtag('view_register_send_sms');
    if (telInputRef.current) {
      telInputRef.current.focus(); // ← 2. マウント時にフォーカス
    }
  }, []);

  return (
    <div>
      <div>
        <Analytics title="携帯電話番号入力" />
        <div className="Register m-auto">
          <div className="App-tel">
            <div className="auth-logo">
              <img src="/img/header_logo.png" alt="LAUNDRY PACK" />
            </div>
            <div className="tel-title">{"新規登録(SMS認証)"}</div>
            <div className="App-comment">{"本人確認のため、携帯電話のSMS(ショートメッセージサービス)を利用して認証を行います。電話番号が他のお客様に公開されることはありません。"}</div>
            <div className="App-telno">
              <input ref={telInputRef} type="tel" value={tel} onChange={e => setTel(e.target.value)} placeholder="例）09012345678" className="form-control" />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px',
            }}>
              {tel.length === 11 ? <button className="button-next" onClick={openModal}>{"次へ"}</button> : <button className="button-next-g">{"次へ"}</button>}
            </div>
            {/* 新規登録のLINE導線は廃止(2026-08-15)。新規はSMS認証に一本化し、
                LINEは既存ユーザーのログイン/連携(通知チャネル)のみで使う方針 */}
            <div className="text-center mt-3">
              <Link to="/login" className="text-black">ログインはこちら</Link>
            </div>
          </div>
        </div>
        <Modal>
          <div className="modal rounded p-4">
            <div className="">
              <div className="row">
                <div className="col-12 text-right">
                  <IoClose onClick={closeModal} className="h2 text-gray-dark"/>
                </div>
              </div>
              <div className="h5 text-center mb-2">
                {tel}
              </div>
              <div className="mb-4">
                上記の電話にSMSで認証番号を送ります。電話番号を変更する場合はキャンセルを押してください。
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <div className="text-center">
                    <button className="btn btn-oval btn-outline-secondary btn-half form-control" onClick={closeModal}>キャンセル</button>
                  </div>
                </div>
                <div className="col-6">
                  <div className="text-center">
                    <button className="btn btn-oval btn-yellow btn-half form-control" onClick={send_sms}>認証番号を送る</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
      </div>
    </div>
  );
}
